import { clientFetch } from '../clientFetch';
/*
 * Doctor autocomplete
 */

export const doctorAutocomplete = ({ input, lat, lon }, signal) => {
  return clientFetch(`/autocomplete/doctor`, {
    params: {
      input,
      lat,
      lon,
    },
    signal,
  });
};
